<a class="skip-link" href="#main">Към съдържанието</a>

<header class="site-header">
  <div class="container header-inner">
    <a routerLink="/" class="brand" aria-label="Имотомер — начало">
      <svg class="brand-mark" width="24" height="24" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <!-- Покрив със стрехи -->
        <path d="M3 14L16 4l13 10" stroke-width="2.5" />
        <!-- Стени и под -->
        <path d="M6.5 14v14h19V14" stroke-width="2.1" opacity="0.65" />
        <!-- Чертичка изцяло вътре в къщичката -->
        <path d="M10 23.5L14 18l3 3l5-8" stroke-width="2.6" />
      </svg>
      <span class="brand-name">Имото<b>мер</b></span>
    </a>

    <button type="button" class="nav-toggle" (click)="navOpen.set(!navOpen())" [attr.aria-expanded]="navOpen()"
      aria-controls="site-nav" aria-label="Отвори менюто">
      ☰
    </button>

    <nav id="site-nav" class="site-nav" [class.open]="navOpen()" aria-label="Основна навигация"
      (click)="navOpen.set(false)">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Обзор</a>
      <a routerLink="/gradove" routerLinkActive="active">Градове</a>
      <a routerLink="/sravnenie" routerLinkActive="active">Сравнение</a>
      <a routerLink="/obiavi" routerLinkActive="active">Обяви</a>
      <a routerLink="/metodologia" routerLinkActive="active">Методология</a>
    </nav>

    <button type="button" class="theme-toggle" (click)="theme.toggle()"
      [attr.aria-label]="theme.theme() === 'dark' ? 'Светла тема' : 'Тъмна тема'">
      {{ theme.theme() === 'dark' ? '☀' : '☾' }}
    </button>
  </div>
</header>

<main id="main" class="container">
  <router-outlet />
</main>

<footer class="site-footer">
  <div class="container">
    <p>
      Имотомер — аналитичен барометър на жилищния пазар в България (офертни пазарни цени от обяви).
      @if (dataSource(); as note) {
      {{ note }}
      }
      <a routerLink="/metodologia">Методология и източници</a>
    </p>

    <div class="footer-cities">
      <span class="kicker">Цени на имоти по градове</span>
      <div class="footer-city-links">
        <a routerLink="/grad/sofiya">София</a> ·
        <a routerLink="/grad/plovdiv">Пловдив</a> ·
        <a routerLink="/grad/varna">Варна</a> ·
        <a routerLink="/grad/burgas">Бургас</a> ·
        <a routerLink="/grad/ruse">Русе</a> ·
        <a routerLink="/grad/stara-zagora">Стара Загора</a> ·
        <a routerLink="/grad/veliko-tarnovo">Велико Търново</a> ·
        <a routerLink="/grad/pleven">Плевен</a> ·
        <a routerLink="/grad/blagoevgrad">Благоевград</a> ·
        <a routerLink="/grad/nesebar">Несебър</a> ·
        <a routerLink="/grad/pomorie">Поморие</a> ·
        <a routerLink="/grad/gorna-oryahovitsa">Горна Оряховица</a> ·
        <a routerLink="/grad/dimitrovgrad">Димитровград</a> ·
        <a routerLink="/grad/asenovgrad">Асеновград</a> ·
        <a routerLink="/grad/kazanlak">Казанлък</a> ·
        <a routerLink="/gradove" class="all-cities-link">Всички 75 града &rarr;</a>
      </div>
    </div>

    <p class="cross-promo">
      <span class="kicker">Още от TUR-92</span>
      Автокранове под наем във Велико Търново и региона — за строителство, монтаж и
      товаро-разтоварни дейности.
      <a href="https://tur92.com/" target="_blank" rel="noopener">Вижте TUR-92 &rarr;</a>
    </p>
  </div>
</footer>